import { headerKeys } from "@/config/general";
import {
  NOT_LOGGED_IN_ERROR_STATUS,
  OK_STATUS,
  parseFrontendError,
} from "@/fe-core/helpers/general";
import { IEligibleJackpotsResponse } from "@/fe-core/meta/interfaces/eligibleJackpots";
import { IJsonResponse } from "@/fe-core/meta/interfaces/root";
import { eligibleJackpotActionTypes } from "@/fe-core/meta/types/eligibleJackpots";
import { methodTypes } from "@/fe-core/meta/types/root";
import {
  all,
  AllEffect,
  ForkEffect,
  put,
  select,
  takeLatest,
} from "redux-saga/effects";
import {
  getEligibleJackpotsFailure,
  getEligibleJackpotsSuccess,
} from "../actions/eligibleJackpotsActions";
import { clearState } from "../actions/rootActions";
import { sessionDataSelector } from "../selectors/sessionSelectors";

function* getEligibleJackpotsSaga() {
  try {
    const { sessionId } = yield select(sessionDataSelector);

    const response: IJsonResponse<IEligibleJackpotsResponse> = yield fetch(
      `/api/user/eligibleJackpots`,
      {
        method: methodTypes.GET,
        headers: new Headers({
          [headerKeys.SESSION_ID]: sessionId,
        }),
      }
    );
    const { status } = response;
    const responsePayload: IEligibleJackpotsResponse = yield response.json();

    if (responsePayload?.status === OK_STATUS && status === 200) {
      yield put(getEligibleJackpotsSuccess(responsePayload.data || []));
    } else if (
      responsePayload?.status === NOT_LOGGED_IN_ERROR_STATUS ||
      status === 401
    ) {
      yield put(
        getEligibleJackpotsFailure({ message: responsePayload?.status })
      );
      yield put(clearState());
    } else {
      yield put(
        getEligibleJackpotsFailure({ message: responsePayload?.status })
      );
    }
  } catch (error) {
    yield put(getEligibleJackpotsFailure(parseFrontendError(error)));
  }
}

function* eligibleJackpotSaga(): Generator<
  AllEffect<ForkEffect<never>>,
  void,
  unknown
> {
  yield all([
    takeLatest(
      eligibleJackpotActionTypes.GET_ELIGIBLE_JACKPOTS_REQUEST,
      getEligibleJackpotsSaga
    ),
  ]);
}

export default eligibleJackpotSaga;
